import { Engine } from '../../core/Engine';
import { RotateTowardCommand } from '../Commands';
import { Image } from '../../entities/Drawable/Image';

export class RotateTowardCommandHandler {
    private engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: RotateTowardCommand) {
        const obj = this.engine.find(command.uuid);
        const oldAngle = obj.angle;
        obj?.transform.rotateToward(command.position, this.engine.selectedOffset);
        if (obj instanceof Image && obj.clipPath) {
            const delta = obj.angle - oldAngle;
            obj.clipPath.transform.rotate(delta);
        }
    }
}
